/**
 * Local storage keys
 */
export const PREFERRED_LANG_KEY = "preferredLang";
export const USER_ORG_ID = "userOrgId";
export const USERNAME = "username";
export const SELECTED_WORKSPACE_ID = "selectedWorkspaceId";
export const SELECTED_OBJECT_ID = "selectedObjectId";
export const SELECTED_VIEW_ID = "selectedViewId";
export const SELECTED_DASHBOARD_ID = "selectedDashboardId";
export const VIEW_COLUMNS_SIZING = "viewColumnsSizing-";
export const APP_SIDEBAR_COLUMN_SIZE = "appSidebarColumnSize-";
export const SELECTED_PERIOD = "selectedPeriod-";
export const SHOW_ALL_LINES = "showAllLines-";
export const VIEW_FOLDER_COLLAPSED = "viewFolderCollapsed-";
export const SEEN_ANNOUNCEMENT_IDS = "seenAnnouncementIds";

export const DEFAULT_COLUMN_WIDTH = 150;
export const SELECT_COLUMN_WIDTH = 30;
export const MIN_COLUMN_WIDTH = 25;
// Checkbox icon (16px) + horizontal padding (8px on each side): the icon must never shrink.
export const CHECKBOX_COLUMN_MIN_WIDTH = 32;
export const GROUP_ROW_HEIGHT = 48;
export const LINE_ROW_HEIGHT = 44;
export const DEFAULT_ORDER_INCREMENT = 100;
export const COMPOZZ_BLUE_RGB = [154, 229, 229];
export const GROUP_BASE_COLOR = "#f3f4f6";

export const CURRENCY_DEFAULT_SYMBOL = "";
export const CURRENCY_DEFAULT_SYMBOL_BEFORE = false;

export const DECIMAL_DEFAULT_SEPARATOR = ",";
export const DECIMAL_DEFAULT_THOUSAND_SEPARATOR = " ";
export const DECIMAL_DEFAULT_DECIMAL_PLACES = 2;

export const DEFAULT_TEXT_FORMAT = "NONE";
export const DEFAULT_PERIOD_FORMAT = "NONE";
export const DEFAULT_NUMBER_FORMAT = undefined;
export const DEFAULT_DATE_FORMAT = "FR";
export const CURRENCY_SYMBOLS = ["€", "$", "£", "USD"];
export const DEFAULT_CURRENCY_SYMBOL = "€";
export const DEFAULT_CURRENCY_SYMBOL_BEFORE = false;

export const PATH_SEPARATOR = ">";
export const FIELD_SEPARATOR = "/";
export const DIRECTION_SEPARATOR = "-";
export const SOURCE_SEPARATOR = ":";

const DEFAULT_BASE_URL = "https://localhost";
export const BASE_URL = window.env?.REACT_APP_COMPOZZ_BASE_URL || DEFAULT_BASE_URL;

// Progressive loading (invisible pagination) of flat views: the first page
// renders immediately, remaining pages load in the background. Enabled by
// default; kill switch: localStorage.setItem("progressiveLoading", "false").
export const PROGRESSIVE_LOADING_KEY = "progressiveLoading";
export const FIRST_PAGE_SIZE = 50;
// Background page sizes ramp up to keep the paints cheap right after the
// first render; the last value repeats for all remaining pages.
export const NEXT_PAGE_SIZES = [250, 500, 1000];
export const nextPageSize = (pageIndex: number): number =>
    NEXT_PAGE_SIZES[Math.min(pageIndex, NEXT_PAGE_SIZES.length - 1)];
export const isProgressiveLoadingEnabled = (): boolean =>
    localStorage.getItem(PROGRESSIVE_LOADING_KEY) !== "false";
